document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('custom-dev-popup'),
    closeBtn = document.getElementById('custom-dev-popup-close'),
    subscribeBtn = document.getElementById('custom-dev-subscribe-btn'),
    title = document.getElementById('custom-dev-popup-title'),
    description = document.getElementById('custom-dev-popup-desc'),
    descriptionRequired = document.getElementById(
      'custom-dev-popup-desc-required'
    ),
    textRequired = document.getElementById('custom-dev-popup-required'),
    textOption = document.getElementById('custom-dev-popup-option'),
    textThirdParty = document.getElementById('custom-dev-popup-thirdparty'),
    acceptTerms = document.getElementById('custom-dev-accept-terms'),
    acceptOption = document.getElementById('custom-dev-accept-option'),
    acceptThirdParty = document.getElementById('custom-dev-accept-thirdparty'),
    subscribeForm = document.getElementById('custom-dev-subscribe-form'),
    spinner = document.getElementById('spinner'),
    emailInput = document.getElementById('custom-dev-email'),
    translations = {
      en: {
        title:
          'Subscribe to our newsletter and get 10% off your first order.**',
        description: '(**) Not applicable to the Como 1907 Adidas collections.',
        button: 'Subscribe',
        descriptionRequired:
          "I declare that I have read the information on the processing of <a href='https://shop.comofootball.com/en/pages/privacy-policy' target='_blank' style='color:#fff'>personal data</a>.",
        textRequired:
          'I consent to the processing of my personal data to receive direct marketing communications (Purpose C).',
        textOption:
          'I consent to the processing of my personal data for profiling activities (Purpose D).',
        textThirdParty:
          'I consent to the disclosure of my personal data to third-party companies (Purpose F).',
        placeholder: {
          email: 'Email',
        },
        alert: {
          email: 'Invalid email format',
          emailExists: 'Email is already registered',
          success: 'Successfully registered, check your email',
        },
      },
      it: {
        title:
          'Iscriviti alla nostra newsletter e ottieni il 10% di sconto sul tuo primo ordine.**',
        description: '(**) Non applicabile alla collezione Como 1907 Adidas.',
        button: 'Iscriviti',
        descriptionRequired:
          "Dichiaro di aver preso visione dell'informativa sul trattamento dei <a href='https://shop.comofootball.com/pages/privacy-policy' target='_blank' style='color:#fff'>dati personali</a>.",
        textRequired:
          'Acconsento al trattamento dei miei dati personali per ricevere comunicazioni di marketing diretto (finalità C)',
        textOption:
          'Acconsento al trattamento dei miei dati personali per attività di profilazione (finalità D)',
        textThirdParty:
          'Acconsento alla comunicazione dei miei dati personali a società terze (finalità F)',
        placeholder: {
          email: 'Email',
        },
        alert: {
          email: 'Formato e-mail non valido',
          emailExists: "L'email \xE8 gi\xE0 registrata",
          success: 'Riuscito, controlla la tua email',
        },
      },
    };

  function showPopup() {
    popup.style.display = 'flex';
    localStorage.setItem('lastPopupDisplayTime', Date.now());
  }

  closeBtn.onclick = function () {
    popup.style.display = 'none';
    sessionStorage.setItem('popupDisplayed', 'true');
  };

  function changeLanguage(lang) {
    if (translations[lang]) {
      title.innerHTML = translations[lang].title;
      description.innerHTML = translations[lang].description;
      subscribeBtn.textContent = translations[lang].button;
      descriptionRequired.innerHTML = translations[lang].descriptionRequired;
      textRequired.textContent = translations[lang].textRequired;
      textOption.textContent = translations[lang].textOption;
      textThirdParty.textContent = translations[lang].textThirdParty;
      emailInput.placeholder = translations[lang].placeholder.email;
    }
  }

  function shouldShowPopup() {
    const lastPopupDisplayTime = localStorage.getItem('lastPopupDisplayTime');
    if (!lastPopupDisplayTime) {
      return true;
    }
    const hoursSinceLastDisplay =
      (Date.now() - lastPopupDisplayTime) / (1000 * 60 * 60);
    return hoursSinceLastDisplay >= 72;
  }

  if (
    !sessionStorage.getItem('popupDisplayed') &&
    !document.body.classList.contains('logged-in') &&
    shouldShowPopup()
  ) {
    showPopup();
  }

  acceptTerms.addEventListener('change', function () {
    subscribeBtn.disabled = !acceptTerms.checked;
  });

  function detectCountryAndChangeLanguage() {
    const availableMarkets = [
      'AT',
      'BE',
      'BG',
      'CZ',
      'CY',
      'HR',
      'DK',
      'EE',
      'FI',
      'FR',
      'DE',
      'GR',
      'IE',
      'IT',
      'LT',
      'LU',
      'MT',
      'NO',
      'NL',
      'PL',
      'PT',
      'GB',
      'RO',
      'SK',
      'SI',
      'ES',
      'SE',
      'CH',
      'UA',
      'HU',
      'SA',
      'CN',
      'KR',
      'AE',
      'JP',
      'IN',
      'ID',
      'IQ',
      'IL',
      'MY',
      'HK',
      'SG',
      'TR',
      'AU',
      'NZ',
      'CA',
      'MX',
      'US',
      'AR',
      'BR',
      'CL',
    ];

    fetch('https://api.ipinfo.io/lite/me?token=430aff43ff8559')
      .then((response) => response.json())
      .then((data) => {
        const detectedCountry = data.country_code;
        console.log('Detected country:', detectedCountry);

        // Card #27: only switch language via the /en URL path. The country /
        // market is handled by Shopify's native localization cookie, so we never
        // append ?country= to the URL (keeps internal URLs clean for crawlers).
        if (detectedCountry === 'IT') {
          localStorage.setItem('lang', 'it');
          changeLanguage('it');
        } else if (availableMarkets.includes(detectedCountry)) {
          localStorage.setItem('lang', 'en');
          sessionStorage.setItem('redirectAfterPopup', 'true');
          const newUrl = new URL(window.location.href);
          if (!newUrl.pathname.startsWith('/en/') && newUrl.pathname !== '/en') {
            newUrl.pathname = '/en' + newUrl.pathname;
          }
          window.location.href = newUrl.href;
        } else {
          localStorage.setItem('lang', 'it');
          sessionStorage.setItem('redirectAfterPopup', 'true');
          const newUrl = new URL(window.location.href);
          if (newUrl.pathname.startsWith('/en/') || newUrl.pathname === '/en') {
            newUrl.pathname = newUrl.pathname.replace(/^\/en/, '');
            if (!newUrl.pathname) newUrl.pathname = '/';
          }
          window.location.href = newUrl.href;
        }
      })
      .catch((error) => {
        console.error('Error detecting country:', error);
        localStorage.setItem('lang', 'it');
        sessionStorage.setItem('redirectAfterPopup', 'true');
        const newUrl = new URL(window.location.href);
        if (newUrl.pathname.startsWith('/en/') || newUrl.pathname === '/en') {
          newUrl.pathname = newUrl.pathname.replace(/^\/en/, '');
          if (!newUrl.pathname) newUrl.pathname = '/';
        }
        window.location.href = newUrl.href;
      });
  }
  const langParam = new URLSearchParams(window.location.search).get('lang');
  const detectedLang = localStorage.getItem('lang');
  let currentLang = 'en';

  if (langParam && translations[langParam]) {
    changeLanguage(langParam);
    currentLang = langParam;
    if (!sessionStorage.getItem('popupDisplayed')) {
      showPopup();
    }
  } else if (detectedLang && translations[detectedLang]) {
    changeLanguage(detectedLang);
    currentLang = detectedLang;
  } else if (!sessionStorage.getItem('popupDisplayedAfterRedirect')) {
    detectCountryAndChangeLanguage();
    sessionStorage.setItem('popupDisplayedAfterRedirect', 'true');
  }

  if (sessionStorage.getItem('redirectAfterPopup')) {
    showPopup();
    sessionStorage.removeItem('redirectAfterPopup');
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email);
  }

  subscribeBtn.addEventListener('click', function () {
    const email = emailInput.value.trim();
    const country = currentLang;
    let errorMessage = '';
    if (!validateEmail(email)) {
      errorMessage = translations[currentLang].alert.email;
      alert(errorMessage);
      return;
    }
    spinner.style.display = 'block';
    subscribeBtn.disabled = true;
    const formData = {
      email,
      country,
      checkOption: acceptOption.checked ? '1' : '0',
      checkThird: acceptThirdParty.checked ? '1' : '0',
    };
    fetch(
      'https://7yfu566wydvhbcgyezrce5qani0vkiun.lambda-url.eu-south-1.on.aws/',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        spinner.style.display = 'none';
        subscribeBtn.disabled = false;
        if (data.code === 'ER') {
          alert(translations[currentLang].alert.emailExists);
        } else if (data.code === 'SC') {
          alert(translations[currentLang].alert.success);
          popup.style.display = 'none';
        }
      })
      .catch((error) => {
        spinner.style.display = 'none';
        subscribeBtn.disabled = false;
        console.error('Error:', error);
      });
  });
});
